// Keeps the campaign sequence table's column headers parked directly beneath
// its track head, which is itself sticky at the top of the window.
//
// The offset has to be MEASURED rather than hardcoded: the head is two lines
// plus padding and grows a line when its meta text wraps, so a constant would
// leave a gap at one window width and overlap at another.
//
// Lives here rather than inline in the view so the zero-height guard below is
// covered by CI. It is the one part of this that could look broken rather than
// merely imperfect, and it is a conditional — exactly the thing a future edit
// could quietly undo.

export const HEAD_HEIGHT_VAR = '--cs-head-h';

// Write each card's head height onto its table as a custom property, which the
// stylesheet reads as `top` for the sticky column headers.
export function syncStickyOffset(root = document) {
  root.querySelectorAll('details[data-track]').forEach((card) => {
    const head = card.querySelector('summary.cs-card__head');
    const table = card.querySelector('.cs-table');

    if (!head || !table) return;

    // ONLY when something was actually measured. A zero — no layout yet, or a
    // hidden card — would set top:0 and park the headers UNDERNEATH the track
    // head rather than below it. Leaving the property unset lets the
    // stylesheet's fallback hold, which is merely approximate instead of wrong.
    const height = head.offsetHeight;

    if (height > 0) table.style.setProperty(HEAD_HEIGHT_VAR, `${height}px`);
  });
}

// Measure now, and again whenever the head's height could have changed: on
// resize (its meta text rewraps) and when a section opens (its table gets a
// height for the first time).
//
// Returns false when this page has no such cards, so the pack can call it
// unconditionally.
export function initStickyOffsets(root = document) {
  const cards = root.querySelectorAll('details[data-track]');

  if (!cards.length) return false;

  const sync = () => syncStickyOffset(root);

  sync();
  window.addEventListener('resize', sync);
  cards.forEach((card) => card.addEventListener('toggle', sync));

  return true;
}
